import isStringDefined from './is-string-defined';

export default function isStringNotDefined(str: any): str is null {
  if (isStringDefined(str)) {
    return false;
  }
  return true;
}
